import { JetView } from 'webix-jet'; // Importing JetView from webix-jet framework
import FilterPagoNotaRetiro from 'views/cash/pagoNotaRetiro/filterPagoNotaRetiro'; // Importing filter component
import PagoNotaRetiro from 'views/cash/pagoNotaRetiro/PagoNotaRetiro'; // Importing payment component
import TablePagoNotaRetiro from 'views/cash/pagoNotaRetiro/tablePagoNotaRetiro'; // Importing table component
import { devConfig } from 'config/config'; // Importing development configuration

/**
 * Class representing the payment view for Nota Retiro.
 * @extends JetView
 */
export default class pagoNotaRetiroView extends JetView {
    /**
     * Configures the UI components of the view.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const theme = this.app.config.theme; // Current theme configuration
        const toolbar = {
            // Toolbar configuration
            view: 'toolbar',
            css: 'highlighted_header header6',
            paddingX: 5,
            paddingY: 5,
            height: 40,
            cols: [
                {
                    view: 'pager', // Pager component for navigation
                    id: 'pagerA',
                    template:
                        '{common.first()}{common.prev()}&nbsp; {common.pages()}&nbsp; {common.next()}{common.last()}',
                    autosize: false,
                    height: 35,
                    size: devConfig.getDefaultDataFetch(), // Default data fetch size
                },
            ],
        };
        const button = {
            // Button configuration
            margin: 10,
            id: 'buttonPagarNotaRetiro',
            cols: [
                {},
                {
                    view: 'button', // Button for payment action
                    value: _('Pago Nota Retiro'), // Button label
                    type: 'form',
                    autowidth: true,
                    click: () => {
                        // Click event handler
                    },
                },
            ],
        };
        const left = {
            // Left side layout configuration
            rows: [
                {
                    view: 'toolbar', // Toolbar for navigation
                    css: theme,
                    elements: [
                        {
                            width: 30,
                            css: 'back-button', // Back button styling
                            view: 'button',
                            type: 'icon',
                            icon: 'wxi-angle-left', // Back icon
                            id: 'back-button',
                            align: 'center',
                            click: () => {
                                // Click event for back button
                                $$('FilterPagoNotaRetiro').show(); // Show filter component
                                $$('FilterPagoNotaRetiro').clear(); // Clear filter data
                                $$('FilterPagoNotaRetiro').clearValidation(); // Clear validation
                                $$('formPagoNotaRetiro').hide(); // Hide payment form
                                $$('back-button').hide(); // Hide back button
                            },
                        },
                        { view: 'label', label: _('Pago Nota Retiro') }, // Label for the view
                        {
                            type: 'wide',
                            css: 'close-bottom', // Close button styling
                            cols: [
                                {
                                    view: 'icon', // Close icon
                                    icon: 'wxi-close',
                                    bottom: 20,
                                    right: 35,
                                    width: 30,
                                    height: 30,
                                    click: () => this.show('/top/dashboard'), // Navigate to dashboard on click
                                },
                            ],
                        },
                    ],
                },
                FilterPagoNotaRetiro, // Including filter component
                PagoNotaRetiro, // Including payment component
            ],
        };
        webix.ui.fullScreen(); // Set the UI to full screen mode
        return {
            // Return the main configuration object
            id: 'a5',
            type: 'clean',
            view: 'form',
            scroll: 'y',
            rows: [
                {
                    responsive: 'a5',
                    type: 'wide',
                    cols: [left], // Left side layout
                },
            ],
        };
    }

    /**
     * Initializes the view components.
     */
    init() {
        $$('back-button').hide(); // Initially hide the back button
    }
}

// FILE DOCUMENTED
